import { Component } from '@angular/core';
import { PageTitleService } from '../../../shared/page-title.service';

@Component({
    selector: 'app-page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    standalone: false
})
export class PageTitleComponent {
  pageTitle$ = this.pageTitleService.title;

  constructor(public pageTitleService: PageTitleService) {}
}
